<template>
    <div
        class="modal fade"
        id="callback"
        tabindex="-1"
        role="dialog"
        aria-labelledby="callbackLabel"
        aria-hidden="true"
        style="padding-right: 0px !important"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>
                        <img :src="sellerAvatar" class="contactavatar" />
                        {{ sellerName }}
                    </h5>

                    <button
                        id="close-callback"
                        type="button"
                        class="btn float-right"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true" class="h4">X</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="p-2">
                        <h5>{{ textBlocks.contact_cta }}</h5>
                    </div>
                    <div class="row d-flex justify-content-center mt-3">
                        <div
                            v-if="showCallback"
                            class="text-center"
                            :class="colClass"
                            style="padding-left: 5px; padding-right: 5px"
                        >
                            <a
                                href="#"
                                class="callbackbtn"
                                @click.prevent="requestCallback"
                            >
                                <span class="h3">&#x1F514;</span>
                                <p
                                    class="py-2 text-dark"
                                    style="text-decoration: none"
                                >
                                    Ring mig
                                </p>
                            </a>
                        </div>

                        <div
                            v-if="showPhone"
                            class="text-center"
                            :class="colClass"
                            style="padding-left: 5px; padding-right: 5px"
                        >
                            <a :href="`tel:${sellerPhone}`" class="callbackbtn">
                                <span class="h3">&#x1F4DE;</span>
                                <p
                                    class="py-2 text-dark"
                                    style="text-decoration: none"
                                >
                                    {{ sellerPhone }}
                                </p>
                            </a>
                        </div>

                        <div
                            v-if="showEmail"
                            class="text-center"
                            :class="colClass"
                            style="padding-left: 5px; padding-right: 5px"
                        >
                            <a
                                :href="`mailto:${sellerEmail}`"
                                class="callbackbtn"
                            >
                                <span class="h3 py-0 text-dark">&#128229;</span>
                                <p
                                    class="py-2 text-dark"
                                    style="text-decoration: none"
                                >
                                    E-post
                                </p>
                            </a>
                        </div>

                        <div
                            class="text-center"
                            :class="colClass"
                            style="padding-left: 5px; padding-right: 5px"
                        >
                            <a
                                role="button"
                                @click="openChatModal"
                                class="callbackbtn"
                            >
                                <span class="h3 py-0"> 💬 </span>
                                <p
                                    class="py-2 text-dark"
                                    style="text-decoration: none"
                                >
                                    Chatta
                                </p>
                            </a>
                        </div>

                        <div
                            v-if="validityPassed"
                            class="text-center"
                            :class="colClass"
                            style="padding-left: 5px; padding-right: 5px"
                        >
                            <a
                                type="button"
                                @click="requestQuoteRenewal"
                                class="callbackbtn"
                            >
                                <span class="h3 py-0">&#x1F44D;</span>
                                <p
                                    class="py-2 text-dark"
                                    style="text-decoration: none"
                                >
                                    Förnya offert
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="callbackRequested" class="p-3">
                    Din förfrågan har tagits emot. Vi kontaktar dig så snart som
                    möjligt!
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.contactavatar {
    width: 40px;
    border-radius: 50%;
    margin-right: 10px;
}
.callbackbtn h5 {
    border-radius: 7px;
    width: 100%;
    margin-left: 0%;
    padding: 20px 0px 20px 0px;
    color: black;
}
.callbackbtn:hover {
    text-decoration: none;
}
.callbackbtn:focus {
    outline: none;
}
</style>

<script setup>
import axios from "axios";
import "bootstrap";
import { computed, ref } from "vue";
import { route } from "ziggy";

import { useSwal } from "../../composables/useSwal";

const props = defineProps({
    quoteKey: { type: String, default: undefined },
    customerName: { type: String, default: undefined },
    sellerName: { type: String, default: undefined },
    sellerAvatar: { type: String, default: undefined },
    sellerPhone: { type: String, default: null },
    sellerEmail: { type: String, default: null },
    hideCallback: { type: [String, Boolean], default: false },
    textBlocks: { type: Object, default: () => ({}) },
    validityPassed: { type: [String, Boolean], default: false },
});

const swal = useSwal();
const callbackRequesting = ref(false);
const callbackRequested = ref(false);
const requestingRenewal = ref(false);
const showPhone = computed(() => props.sellerPhone && props.sellerPhone.length > 3);
const showEmail = computed(() => props.sellerEmail && props.sellerEmail.length > 3);
const showCallback = computed(() => !props.hideCallback);
const visibleButtonCount = computed(() =>
    1 + Number(showCallback.value) + Number(showPhone.value) +
    Number(showEmail.value) + Number(Boolean(props.validityPassed))
);
const colClass = computed(() => {
    const count = visibleButtonCount.value;
    const perRow = count <= 3 ? count : count === 4 ? 2 : 3;
    return `col-${12 / perRow}`;
});

async function requestCallback() {
    if (callbackRequesting.value) {
        return;
    }
    callbackRequesting.value = true;
    try {
        await axios.post(route("quotes.requestCallback", props.quoteKey));
        callbackRequested.value = true;
    } catch (error) {
        callbackRequesting.value = false;
        alert("Din callback-förfrågan kunde ej hanteras, vad god försök igen senare.");
        console.warn(error);
    }
}

async function requestQuoteRenewal() {
    if (requestingRenewal.value) {
        return;
    }
    requestingRenewal.value = true;
    try {
        await axios.post(route("quotes.requestRenewal", props.quoteKey));
        await showRenewalMessage({
            text: "Begäran om förnyelse har mottagits",
            icon: "success",
        });
    } catch (error) {
        requestingRenewal.value = false;
        await showRenewalMessage({
            icon: "error",
            text: "Din begäran om förnyelse kunde inte hanteras, försök igen senare.",
        });
        console.warn(error);
    }
}

function showRenewalMessage(options) {
    const primaryColor = window.getComputedStyle(document.body).getPropertyValue("--primary-color");
    return swal.fire({
        ...options,
        iconColor: primaryColor,
        confirmButtonColor: primaryColor,
    });
}

function openChatModal() {
    document.getElementById("close-callback").click();
    window.dispatchEvent(new CustomEvent("ChatModalOpen", {
        detail: { shouldOpen: true },
        bubbles: false,
        cancelable: true,
    }));
}
</script>
